import React from 'react'
import { connect } from 'react-redux'
import PaymentsList from './Components/PaymentsList/PaymentsList'
import {
  getGroupPaymentsRequest,
  resolveOmkPaymentLabelsRequest
} from './Redux/actions'
import { labelsNeededFor } from './lib/labels'

class GroupPaymentDashboard extends React.Component {
  constructor(props) {
    super(props)
    this.getPayments = this.getPayments.bind(this)
  }

  // The first page is not requested here: PaymentsList's table owns the page
  // and the page size, and asks for page 1 as it mounts. Fetching here as well
  // would either duplicate that request or contradict its page size.
  componentDidUpdate(prevProps) {
    const previous = prevProps.omkGroupPaymentData.payments
    const current = this.props.omkGroupPaymentData.payments
    if (current && current !== previous) {
      // Rows arrive with guids only — resolve the group names for this page.
      this.props.dispatch(
        resolveOmkPaymentLabelsRequest(labelsNeededFor(current.data))
      )
    }
  }

  getPayments(payload) {
    this.props.dispatch(getGroupPaymentsRequest(payload))
  }

  render() {
    const data = this.props.omkGroupPaymentData
    return (
      <PaymentsList
        payments={data.payments}
        loader={data.payments_loader}
        error={data.payments_error}
        groupLabels={data.group_labels}
        getPayments={this.getPayments}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    omkGroupPaymentData: state.omkGroupPaymentData
  }
}

export default connect(mapStateToProps)(GroupPaymentDashboard)
